import AreaChip from "Components/Common/Chip/AreaChip";
import RoleIcon from "Components/Icon/RoleIcon";
import i18n from "i18next";
import AttachFileIcon from "mdi-react/AttachFileIcon";
import InformationOutlineIcon from "mdi-react/InformationOutlineIcon";
import { ChecklistTemplate } from "Models/Checklists/ChecklistTemplate";
import * as React from "react";
import { connect } from "react-redux";
import { IChecklistTemplateState } from "Store/ChecklistTemplates/ChecklistTemplateState";
import { IApplicationState } from "Store/Store";
import styles from "./ChecklistTemplateBlockDetailsBlock.scss";

interface IProps {
    checklistTemplate: ChecklistTemplate;
    checklistTemplateState: IChecklistTemplateState;
}

const mapStateToProps = (state: IApplicationState) => ({
    checklistTemplateState: state.checklistTemplateState
});

const ChecklistTemplateBlockDetailsBlock: React.FunctionComponent<IProps> = (props: IProps) => (
    <div className={styles.checklistTemplateBlockDetailsBlock}>
        <div className={styles.info}>
            <div className={styles.identifier}>{i18n.t("common.id")}: {props.checklistTemplate.id}</div>
            <div className={styles.taskTemplates}>
                <span className={styles.infoValue}>{i18n.t("common.items")}: {props.checklistTemplate.items.length}</span>
            </div>
            <div className={styles.attachment}>
                <span className={styles.infoValue}>{i18n.t("common.instructions")}: {props.checklistTemplate.totalInstructionCount}</span>
            </div>
        </div>
        <h2>{props.checklistTemplate.name}</h2>
        <div className={styles.bottomInfo}>
            <div className={styles.role}>
                {i18n.t("authentication.role")}: {i18n.t(`authentication.roles.${props.checklistTemplate.role}`)}
            </div>
            {props.checklistTemplate.area && <AreaChip area={props.checklistTemplate.area} size="small" maxPathLength={85} filteredArea={props.checklistTemplateState.currentFilter && props.checklistTemplateState.currentFilter.area} />}
        </div>
    </div>
);

export default connect(mapStateToProps, null)(ChecklistTemplateBlockDetailsBlock);


// WEBPACK FOOTER //
// ./src/Components/Pages/CheckTemplateBlockOverview/ChecklistTemplateBlockView/ChecklistTemplateBlockCard/ChecklistTemplateBlockDetailsBlock/ChecklistTemplateBlockDetailsBlock.tsx